module.exports = __webpack_public_path__ + "img/image_3.6454302d.jpg";